import React from "react";
import { Radio } from "antd-mobile";
import { CheckOutlined } from "@ant-design/icons";

import "./style.scss";

function CustomRadioList({
  defaultValue = "",
  onChange = () => {},
  radioItems = [],
}) {
  return (
    <div className="agent-mobile-custom-radioList">
      <Radio.Group defaultValue={defaultValue} onChange={onChange}>
        {radioItems?.map((item) => {
          return (
            <Radio
              key={item.value}
              block
              value={item.value}
              icon={(checked) =>
                checked ? (
                  <CheckOutlined
                    style={{ color: "var(--adm-color-primary)" }}
                  />
                ) : (
                  ""
                )
              }
              style={{
                "--icon-size": "17px",
                "--font-size": "17px",
              }}
            >
              {item.label}
            </Radio>
          );
        })}
      </Radio.Group>
    </div>
  );
}

export default CustomRadioList;
